export const careerTimeline = [
  {
    id: 'coinfo-pleno',
    category: 'tech',
    period: 'Abr 2025 – Atual',
    title: 'Desenvolvedor Full Stack Java Pleno',
    company: 'Coinfo Informática Ltda',
    location: 'São Paulo – SP',
    summary:
      'Atuação como desenvolvedor pleno, assumindo maior responsabilidade técnica e liderança de projeto interno, participando desde o levantamento de requisitos até a entrega em produção.',
    highlights: [
      'Sustentação e evolução de sistemas críticos',
      'Desenvolvimento de novas funcionalidades com foco em qualidade, performance e estabilidade',
      'Orientação e apoio técnico a desenvolvedores menos experientes',
      'Participação ativa em decisões técnicas e definição de soluções',
      'Deploy, monitoramento e acompanhamento de aplicações em AWS',
    ],
    technologies: [
      'Java 8',
      'Java 25',
      'Spring Boot',
      'Hibernate',
      'JPA',
      'PostgreSQL',
      'JavaScript',
      'jQuery',
      'REST',
      'SOAP',
      'AWS',
      'Docker',
      'Git',
      'Maven',
      'Node.js',
      'React',
      'Flutter',
      'IA (Claude e Cursor)',
    ],
  },
  {
    id: 'coinfo-jr',
    category: 'tech',
    period: 'Fev 2022 – Abr 2025',
    title: 'Desenvolvedor Full Stack Java Júnior',
    company: 'Coinfo Informática Ltda',
    location: 'São Paulo – SP',
    summary:
      'Atuação no desenvolvimento e sustentação de sistemas corporativos, participando ativamente de todo o fluxo de desenvolvimento.',
    highlights: [
      'Sustentação e evolução de sistemas existentes',
      'Correção de bugs e implementação de melhorias contínuas',
      'Desenvolvimento de novas funcionalidades e relatórios',
      'Integração entre sistemas via APIs REST e SOAP',
      'Deploy e acompanhamento de aplicações em ambientes de homologação e produção (AWS)',
    ],
    technologies: [
      'Java 8',
      'Spring Boot',
      'Hibernate',
      'JPA',
      'PostgreSQL',
      'JavaScript',
      'jQuery',
      'REST',
      'SOAP',
      'AWS',
      'Git',
      'Maven',
      'JasperReports',
    ],
  },
  {
    id: 'coinfo-trainee',
    category: 'tech',
    period: 'Fev 2021 – Jan 2022',
    title: 'Trainee de TI',
    company: 'Coinfo Informática Ltda',
    location: 'São Paulo – SP',
    summary:
      'Atuação em sustentação e desenvolvimento de sistemas Progress, com foco na correção de bugs, manutenção de sistemas existentes e apoio na evolução de funcionalidades conforme regras de negócio.',
    highlights: [],
    technologies: ['Progress 4GL', 'SQL', 'PostgreSQL'],
  },
  {
    id: 'coinfo-estagiario',
    category: 'tech',
    period: 'Jan 2020 – Jan 2021',
    title: 'Estagiário de TI',
    company: 'Coinfo Informática Ltda',
    location: 'São Paulo – SP',
    summary:
      'Atuação em suporte técnico a sistemas Progress, realizando atendimento a usuários, análise inicial de problemas e apoio à equipe de desenvolvimento na identificação de falhas e melhorias.',
    highlights: [],
    technologies: ['Progress 4GL', 'SQL', 'Ferramentas de suporte'],
  },
  {
    id: 'bom-agendador',
    category: 'entrepreneur',
    period: 'Jan 2019 – Mai 2020',
    title: 'Desenvolvedor / Co-Fundador',
    company: 'Bom Agendador',
    location: 'São Paulo – SP',
    summary:
      'Atuação na criação de aplicação web e desenvolvimento mobile para otimizar processos de agendamento de serviços. Responsável pela análise de mercado, desenvolvimento técnico, validação do produto e negociação comercial.',
    highlights: [
      'Fundada em janeiro de 2019 e vendida em maio de 2020 para o empresário Marcos Andrade (Presidente da ABIESV, Diretor do CIESP e CEO da Expor Manequins)',
    ],
    technologies: ['.NET', 'JavaScript', 'HTML', 'CSS'],
  },
  {
    id: 'exercito',
    category: 'military',
    period: 'Mar 2014 – Fev 2020',
    title: 'Soldado',
    company: 'Exército Brasileiro — 2º Batalhão de Polícia do Exército',
    location: 'São Paulo – SP',
    summary:
      'Atuação em diferentes funções, incluindo fuzileiro, auxiliar administrativo e mecânico de material bélico leve.',
    highlights: [
      'Nos últimos 4 anos, responsável pelo setor de manutenção',
      'Coordenação de rotinas, controle de equipamentos e apoio técnico à equipe',
      'Desenvolvimento de disciplina, organização e liderança',
    ],
    technologies: [],
  },
];

export const categoryLabels = {
  tech: 'Tecnologia',
  entrepreneur: 'Empreendedorismo',
  military: 'Forças Armadas',
};
